import React from 'react';
import styled from 'styled-components';

import { useMedia } from '@tager/web-core';

import CarBadges from '@/components/CarBadges';
import { useTypedSelector } from '@/store/store';
import { selectDetailedCarData } from '@/store/reducers/detailed-car';

function Badges() {
  const isLaptopOnly = useMedia('(max-width: 1539px) and (min-width: 1260px)');
  const isMobile = useMedia('(max-width: 767px)');
  const data = useTypedSelector(selectDetailedCarData);

  if (!data) {
    return null;
  }

  const {
    warranty,
    dealers,
    testDrive,
    onlinePurchase,
    version,
    options: { onlyOnline },
    media: { video },
  } = data;

  const convertedDealers =
    dealers && dealers.length !== 0
      ? dealers.map(({ address, phone }) => ({
          address: address ?? '',
          phone: phone ?? '',
        }))
      : undefined;

  const guarantee = {
    hint: warranty.hint ?? undefined,
    isVisible: warranty.included,
  };

  return (
    <Component>
      <CarBadges
        testDrive={testDrive.available}
        location={convertedDealers}
        guarantee={guarantee}
        onlyOnline={onlyOnline}
        purchaseOnline={onlinePurchase.available}
        videoReview={video?.url ?? ''}
        version={
          version
            ? { name: version.label ?? '', hint: version.hint ?? '' }
            : undefined
        }
        isLaptop={isLaptopOnly || isMobile}
      />
    </Component>
  );
}

export default Badges;

const Component = styled.div`
  margin-top: 15px;
`;
